import { t, Trans } from "@lingui/macro";
import { GithubLogo, Lock } from "phosphor-react";
import { useContext, useEffect, useState } from "react";
// import { useForm } from "react-hook-form";
// import { useMutation } from "react-query";
import axios from "axios";
// import { Warning } from "../components/Warning";
// import { WelcomeMessage } from "../components/WelcomeMessage";
// import { isError } from "../lib/helpers";
// import { supabase } from "../lib/supabaseClient";
import { Button2, InputWithLabel, P, Page } from "../ui/Shared";
import { PageTitle } from "../ui/Typography";
import { ReactComponent as EmailPassword } from "./EmailPassword.svg";
import { Link, useNavigate } from "react-router-dom";
// import { AuthOtpResponse } from "@supabase/supabase-js";
import { useLocation } from "react-router-dom";
import { useIsLoggedIn } from "../lib/hooks";
import { AppContext } from "../components/AppContext";
import GoogleSVG from "../components/GoogleSVG";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { backendUrl, ssoConfig, frontendUrl } from "../config";
import {
  LoginSocialGoogle,
  IResolveParams,
  LoginSocialGithub,
} from "reactjs-social-login";
// import { Box } from "../slang";
import Spinner from "../components/Spinner";
// type Fields = {
//   email: string;
// };

export default function Login() {
  const [loading, setLoading] = useState(false);
  const { setSession } = useContext(AppContext);
  // check for auth wall warning
  const googleLoginSSO = async (data: any) => {
    try {
      const body = {
        token: data.access_token,
        firstName: data.given_name,
        lastName: data.family_name,
        type: "GOOGLE",
      };
      const response = await axios.post(
        `${backendUrl.baseUrl}/auth/google/`,
        body
      );
      if (response) {
        localStorage.setItem("token", response.data.access_token);
        localStorage.setItem("userEmail", response.data.email);
        localStorage.setItem("loginType", response.data.login_method);
        setSession(response.data);
      }

      if (response.status === 200) {
        setLoading(false);
        navigate("/");
        localStorage.setItem("loading", "false");
        localStorage.setItem("checked", "false");
        localStorage.setItem("diagramTool", "flowchart.fun");
      } else {
        toast.error("Some error occured. Try again.");
      }
    } catch (error: any) {
      toast.error(error?.response?.data.message);
      setLoading(false);
    }
  };
  const githubLoginSSO = async (data: any) => {
    try {
      const body = {
        token: data?.access_token,
        firstName: data?.name.split(" ").shift(),
        lastName: data?.name.split(" ").pop(),
        type: "GITHUB",
      };
      const response = await axios.post(
        `${backendUrl?.baseUrl}/auth/github/`,
        body
      );
      if (response) {
        localStorage.setItem("token", response?.data.access_token);
        localStorage.setItem("userEmail", response?.data.email);
        localStorage.setItem("loginType", response?.data.login_method);
        setSession(response?.data);
      }

      if (response?.status === 200) {
        setLoading(false);
        navigate("/");
        localStorage.setItem("loading", "false");
        localStorage.setItem("checked", "false");
        localStorage.setItem("diagramTool", "flowchart.fun");
      } else {
        toast.error("Some error occured. Try again.");
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.message);
      setLoading(false);
    }
  };
  const { search } = useLocation();
  const [showAuthWallWarning, redirectUrl] =
    checkForAuthWallWarningAndRedirect(search);

  // check and see if there is
  // const { register, handleSubmit } = useForm<Fields>();
  const [success, setSuccess] = useState(false);
  // const { mutate } = useMutation<
  //   AuthOtpResponse,
  //   Record<string, never>,
  //   { email: string }
  // >(
  //   async ({ email }) => {
  //     if (!supabase) throw new Error("No supabase client");
  //     return supabase.auth.signInWithOtp({
  //       email,
  //       options: {
  //         emailRedirectTo: redirectUrl,
  //       },
  //     });
  //   },
  //   {
  //     onSuccess: () => setSuccess(true),
  //   }
  // );

  // Watch log in state and redirect if it changes
  const navigate = useNavigate();
  const { checkedSession, mode } = useContext(AppContext);
  const isLoggedIn = useIsLoggedIn();
  useEffect(() => {
    if (!checkedSession) return;
    if (checkedSession && isLoggedIn) {
      // go to account page
      window.location.href = redirectUrl;
    }
  }, [checkedSession, isLoggedIn, navigate, redirectUrl]);

  // const onSubmit = useCallback(
  //   ({ email }: Fields) => {
  //     mutate({ email });
  //   },
  //   [mutate]
  // );

  // const [newSignUp] = useState(() => {
  //   return window.location.hash === "#success";
  // });

  if (success) {
    return (
      <div className="pt-12 grid justify-items-center content-start gap-4 w-full max-w-[440px] mx-auto text-center">
        <EmailPassword
          width={180}
          height={180}
          className="stroke-foreground dark:stroke-background"
        />
        <P>
          <Trans>
            Check your email for a link to log in.
            <br />
            You can close this window.
          </Trans>
        </P>
        <div className="text-neutral-600 ml-4">
          <p className="text-sm text-neutral-600 dark:text-neutral-400 leading-6">
            <Trans>
              Once in a while the magic link will end up in your spam folder. If
              you don&apos;t see it after a few minutes, check there or request
              a new link.
            </Trans>
          </p>
        </div>
      </div>
    );
  }

  return (
    <Page size="sm">
      {loading && <Spinner />}
      {showAuthWallWarning && <AuthWallWarning />}
      {/* {newSignUp && <WelcomeMessage />} */}
      <PageTitle className="text-center mb-6">{t`Sign In`}</PageTitle>

      <div className="flex items-center justify-center">
        <div className="block">Continue with</div>
        <LoginSocialGoogle
          client_id={`${ssoConfig.googleClientId}`}
          fetch_basic_profile={true}
          typeResponse="accessToken"
          scope={
            "https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile"
          }
          // isOnlyGetToken={true}
          onResolve={async ({ data }: IResolveParams) => {
            console.log(data, "data");

            setLoading(true);
            googleLoginSSO(data);
          }}
          onReject={(err) => {
            console.log(err);
          }}
        >
          <GoogleSVG />
          {/* <img style={{cursor:"pointer"}} src={google} />  */}
        </LoginSocialGoogle>

        <div className="mr-4">OR</div>

        <LoginSocialGithub
          client_id={`${ssoConfig.githubClientId}`}
          client_secret={`${ssoConfig.githubClientSecretKey}`}
          redirect_uri={`${frontendUrl.baseUrl}/l`}
          scope="user:email user"
          onResolve={async ({ provider, data }: IResolveParams) => {
            setLoading(true);
            githubLoginSSO(data);
          }}
          onReject={(err) => {
            console.log(err);
          }}
        >
          <GithubLogo size={22} />
          {/* <img style={{cursor:"pointer"}} src={google} />  */}
        </LoginSocialGithub>
      </div>

      {/* <Button2
        leftIcon={<GoogleSVG />}
        className="!bg-white border-solid border border-neutral-400 py-0 !gap-1 hover:!bg-neutral-100 !text-black"
        // onClick={handleGoogleAuth}
      >
        <Trans>
          Sign in with <span>Google</span>
        </Trans>
      </Button2> */}
      {/* <Button2
        leftIcon={<GithubLogo size={24} />}
        // onClick={handleGithubAuth}
      >
        <Trans>
          Sign in with <span>GitHub</span>
        </Trans>
      </Button2> */}
      <Or />
      <UserPass />
    </Page>
  );
}

function AuthWallWarning() {
  return (
    <div className="bg-yellow-100 text-foreground p-4 text-center text-md grid gap-2 mb-6 leading-normal rounded-lg">
      <p className="font-bold">
        <Trans>You need to log in to access this page.</Trans>
      </p>
      <p className="text-wrap-balance">
        <Trans>
          To learn more about why we require you to log in, please read{" "}
          <Link to="/blog/post/important-changes-coming" className="underline">
            this blog postimport Loading from '../components/Loading';
          </Link>
          .
        </Trans>
      </p>
    </div>
  );
}

function checkForAuthWallWarningAndRedirect(search: string): [boolean, string] {
  const params = new URLSearchParams(search);
  const showAuthWallWarning = params.get("showAuthWallWarning") === "true";
  const redirectUrl = decodeURIComponent(params.get("redirectUrl") || "/"); // default to home page
  return [showAuthWallWarning, redirectUrl];
}

function Or() {
  return (
    <div className="relative my-8">
      <hr />
      <p className="text-center text-neutral-500 leading-normal dark:text-neutral-400 bg-background dark:bg-[#0f0f0f] absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 px-2 -mt-px">
        <Trans>or</Trans>
      </p>
    </div>
  );
}

function UserPass() {
  const [method, setMethod] = useState<"Sign In" | "Sign Up">("Sign In");
  const { setSession, mode } = useContext(AppContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  /* eslint-disable no-useless-escape */
  const passwordRegex =
    /^(?=[A-Za-z0-9@#$%^&*()+!={}~`_\[\]\'\\/:;,.<>?~"|\-\[\]]+$)(?=.*[a-z])(?=.*[0-9])(?=.*[@#$%^&*()+!={}~`_\[\]\'\\/:;,.<>?~"|\-\[\]]).{8,}$/;
  const emailRegex = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/;

  const handleSignIn = async () => {
    if (email && password) {
      if (passwordRegex.test(password)) {
        if (emailRegex.test(email)) {
          const body = {
            email: email,
            password: password,
          };
          try {
            setLoading(true);
            const response = await axios.post(
              `${backendUrl.baseUrl}/auth/signin`,
              body
            );
            if (response) {
              localStorage.setItem("token", response.data.access_token);
              localStorage.setItem("userName", response.data.name);
              localStorage.setItem("userEmail", response.data.email);
              localStorage.setItem("loginType", response.data.login_method);
              setLoading(false);
              setSession(response.data);
            }

            if (response.status === 200) {
              navigate("/");
              localStorage.setItem("loading", "false");
              localStorage.setItem("checked", "false");
              localStorage.setItem("diagramTool", "flowchart.fun");
            } else {
              toast.error("Some error occured. Try again.");
            }
          } catch (error: any) {
            if (error?.response?.status === 403) {
              toast.error("Password incorrect.");
            } else {
              toast.error(error?.response?.data.message);
            }
            setLoading(false);
          }
        } else {
          toast.error("Invalid email.");
        }
      } else {
        toast.error("Password incorrect.");
      }
    } else {
      if (!email) {
        toast.error("Email cannot be empty.");
      }
      if (!password) {
        toast.error("Password cannot be empty.");
      }
    }
  };
  const handleSignUp = async () => {
    if (email && password && firstName && lastName) {
      if (passwordRegex.test(password) && emailRegex.test(email)) {
        const body = {
          firstName: firstName,
          lastName: lastName,
          email: email,
          password: password,
          role: "USER",
        };
        try {
          setLoading(true);
          const response = await axios.post(
            `${backendUrl.baseUrl}/auth/signup`,
            body
          );
          if (response) {
            localStorage.setItem("token", response.data.access_token);
            localStorage.setItem("userName", response.data.name);
            localStorage.setItem("userEmail", response.data.email);
            localStorage.setItem("loginType", response.data.login_method);
            navigate("/");
            localStorage.setItem("loading", "false");
            localStorage.setItem("checked", "false");
            localStorage.setItem("diagramTool", "flowchart.fun");

            setSession(response.data);
            setLoading(false);
          }
        } catch (error: any) {
          console.error("Res: Error:", error);
          toast.error(error?.response?.data.message);
          setLoading(false);
        }
      } else {
        if (!emailRegex.test(email)) {
          toast.error("Invalid Email");
        }
        if (!passwordRegex.test(password)) {
          toast.error(
            "Password must contain atleast,an uppercase letter, lowercase letter, a digit, special character, and should be minimum 8 characters long"
          );
        }
      }
    } else {
      toast.error("Must fill all fields.");
    }
  };
  return (
    <>
      <P>
        <span className="text-[12px] font-mono inline-block mr-2 -translate-y-px text-blue-500">
          <Trans>Choose</Trans>:{" "}
        </span>
        <Trans>
          <button
            className="p-[2px] border-b border-neutral-400 border-solid border-0 opacity-30 data-[active=true]:opacity-100"
            data-active={method === "Sign In"}
            onClick={() => setMethod("Sign In")}
          >
            Sign In
          </button>
          /
          <button
            data-active={method === "Sign Up"}
            className="p-[2px] border-b border-neutral-400 border-solid border-0 opacity-30 data-[active=true]:opacity-100"
            onClick={() => setMethod("Sign Up")}
          >
            Sign Up
          </button>
          with email and password
        </Trans>
      </P>
      <form className="gap-2 grid">
        {method === "Sign Up" ? (
          <>
            <InputWithLabel
              label="First Name"
              inputProps={{
                autoComplete: "first-name",
                required: true,
                type: "text",
                value: firstName,
                disabled: loading,
                onChange: (e) => setFirstName(e.target.value),
              }}
            />
            <InputWithLabel
              label="Last Name"
              inputProps={{
                autoComplete: "last-name",
                required: true,
                type: "text",
                value: lastName,
                disabled: loading,
                onChange: (e) => setLastName(e.target.value),
              }}
            />
          </>
        ) : (
          <></>
        )}
        <InputWithLabel
          label={t`Email`}
          inputProps={{
            autoComplete: "email",
            required: true,
            type: "email",
            value: email,
            disabled: loading,
            onChange: (e) => setEmail(e.target.value),
          }}
        />
        <InputWithLabel
          label={t`Password`}
          inputProps={{
            autoComplete: "current-password",
            required: true,
            type: "password",
            value: password,
            disabled: loading,
            onChange: (e) => setPassword(e.target.value),
          }}
        />
        <Button2
          type="submit"
          className="w-full justify-center"
          leftIcon={<Lock size={24} />}
          data-testid="sign-in-email-pass"
          onClick={(e) => {
            e.preventDefault();
            method === "Sign In" ? handleSignIn() : handleSignUp();
          }}
          disabled={loading}
        >
          {method === "Sign In" ? (
            <Trans>Sign In </Trans>
          ) : (
            <Trans>Sign Up</Trans>
          )}
        </Button2>
        <ToastContainer theme={mode} />
      </form>
      <p className="text-center text-neutral-500 leading-normal dark:text-neutral-400 mb-3 text-xs">
        <Link to="/forgot-password">
          <Trans>Forgot your password?</Trans>
        </Link>
      </p>
    </>
  );
}
